<template>
  <div class="main">
    <div class="content">
      <div class="left">
        <div class="logo"><img :src="require('../assets/footer/logo.png')" alt="logo" /></div>
        <div class="icon">
          <img src="../assets/footer/tele.png" @click="goto('https://t.me/+kBo2NuSmbeY4ZDQ9htt')" style="width: 58px; height: 58px; margin-right: 15px; margin-top: 30px;" />
          <img src="../assets/footer/t.png" @click="goto('https://x.com/@b_incubator')" style="width: 58px; height: 58px; margin-right: 15px; margin-top: 30px;" />
          <img src="../assets/footer/contact_us-GITHUB.png" alt="" style="width: 58px; height: 58px; margin-right: 15px; margin-top: 30px;" />
          <img src="../assets/footer/email_us-email.png" @click="goto('mailto:BIT-network@outlook.com')" style="width: 58px; height: 58px; margin-top: 30px;" />
        </div>
      </div>
      <div class="middle">
        <div class="line">
          <a href="http://doc.bitnetworkbc.com/websiteAboutBit.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: inherit;">
            <div  class="title" style="font-weight: 1000;" font-family="微软雅黑;">{{ $t('footer.content[0]') }}</div>
          </a>
          <a href="http://doc.bitnetworkbc.com/websitePrivacyPolicy.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: inherit;">
            <div style="font-weight: 300;" font-family="微软雅黑;">{{ $t('footer.content[1]') }}</div>
          </a>
          <a href="http://doc.bitnetworkbc.com/websiteTerms.pdf" target="_blank" rel="noopener noreferrer" style="text-decoration: none; color: inherit;">
            <div style="font-weight: 300;" font-family="微软雅黑;">{{ $t('footer.content[2]') }}</div>
          </a>
        </div>
        <div class="line">
          <div class="title" style="font-weight: 1000;" font-family="微软雅黑;">{{ $t('footer.content[3]') }}</div> 
          <div style="font-weight: 300;" font-family="微软雅黑;">{{ $t('footer.content[4]') }}</div>
          <div style="font-weight: 300;" font-family="微软雅黑;">{{ $t('footer.content[5]') }}</div>  
        </div>
        <div class="line">
          <div class="title" style="font-weight: 1000;" font-family="微软雅黑;">{{ $t('footer.content[6]') }}</div>  
          <div style="font-weight: 300;" font-family="微软雅黑;" >{{ $t('footer.content[7]') }}</div>
          <div style="font-weight: 300;" font-family="微软雅黑;" >{{ $t('footer.content[8]') }}</div>
          <div style="font-weight: 300;" font-family="微软雅黑;" >{{ $t('footer.content[9]') }}</div>
        </div>
      </div>

      <div class="right" style="margin-top: 20px;">
        <div class="qrcode">
          <div class="qr" style="position: relative;">
            <img src="../assets/footer/block.png" alt="装饰图片" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; height: 100%;" />></div>
          <div class="qr-text" font-family="微软雅黑;" font-weight="bold;">{{ $t('footer.right') }}</div>
        </div>

        <div class="qrcode">
          <div class="qr" style="position: relative;">
            <img src="../assets/footer/wallet.png" alt="钱包图片" style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%); width: 100%; height: 100%;" />></div>
          <div class="qr-text" font-family="微软雅黑;" font-weight="bold;">{{ $t('footer.download') }}</div>
        </div>


      </div>
    </div>

    <div class="divider"></div>

    <div class="footer" style="margin-top: -20px; margin-bottom: 20px;">
      <div style="font-size: 14px;margin-top: 10px; margin-bottom: 10px; " >
        {{ $t('footer.c') }}
      </div>
      <div style="font-size: 14px; margin-top: 10px; position: relative; left: -50px;" font-family="微软雅黑;">http://bitnetworkbc.com</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(url) {
      window.location.href = url;
    }
  }
}
</script>

<style lang="scss" scoped>
.main {
    box-sizing: border-box;
    display: flex;
    color: #fff;
    flex-direction: column;
    
    position: relative;
    /* 固定画布并居中锚定到视口 */
    width: 100%;
   
    margin: 0 auto;
    justify-content: center;
    align-items: center;

  .content {
    
    display: flex;
    
    // justify-content: center;
    // padding: 30px;
    width: 1200px;
    
    /* 作为绝对定位锚点，右侧二维码等仍以 1920 宽画布相对定位 */
    position: relative;
     margin:  0 auto;


    .left {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-right: 30px;
     


      .logo {
        img {
          width: 293px;
          height: 55px;
        }
      }

      .icon {
        cursor: pointer;

        img {
          width: 48px;
          height: 48px;
          /* margin-left: 10px; */
          margin-top: 15px;
        }
      }
    }

    .middle {
      // border-left: 1px solid black;
      // padding-left: 20px;

      .line {
          width: 160px;
          float: left;

          div {
            font-family: "微软雅黑";
            margin-left: 30px;
            font-size: 14px;
            font-weight: bold;
            line-height: 30px;
            cursor: pointer;
            color: #e8e5e5;


          }

        .title {
          font-family: "bold";
          font-size: 14px;
          color: #fff;

        }


      }
    }

    .right {
      display: flex;
      justify-content: space-between;

      margin-left: auto;
      gap: 25px;


      .qrcode {
        display: flex;
        flex-direction: column;
        gap: 10px;


        .qr {



          width: 120px;
          height: 120px;
          background-color: #fff;
          border: 1px black solid;
        }

        .qr-text {
          font-size: 14px;
          color: #a8a8a8;
          text-align: center;
          font-family: "微软雅黑";
          font-weight: 600px;
        }
      }
    }
  }


  .divider {
    width: 1200px;
    height: 2px;
    background-color:  #a5a1a1;;
    margin: 30px auto 20px auto;
  }

  .footer {
    width: 1200px;
    height: 30px;
    color: #918e8e;
    font-size: 18px;
    font-family: "微软雅黑";
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
  }
}
</style>